<template>
  <div class="button" :class="{
    'button--alternative': alternative,
  }">
    <component class="button__content animated pulse infinite"
      :is="component"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <slot />
    </component>
  </div>
</template>

<script>
export default {
  name: 'VButton',
  inheritAttrs: false,

  props: {
    alternative: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    component() {
      return this.$attrs.to ? 'router-link' : 'a';
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  &:not(:first-child) {
    margin-top: $gridGutter;
  }

  &,
  &__content {
    display: block;
    width: 100%;
  }

  &__content {
    padding: $gridGutter;

    font-family: $fontFamily;
    font-size: font($buttonFontSizeMin, $buttonFontSizeMax);
    line-height: 1.25em;
    text-decoration: none;
    text-align: center;
    text-transform: uppercase;
    color: $buttonColor;

    background-color: $buttonBackgroundColor;

    cursor: pointer;

    &:hover {
      background-color: $buttonBackgroundColorHover;
      color: $buttonColorHover;
    }
  }

  &--alternative &__content {
    background-color: $buttonAlternativeBackgroundColor;
    color: $buttonAlternativeColor;

    &:hover {
      background-color: $buttonAlternativeBackgroundColorHover;
      color: $buttonAlternativeColorHover;
    }
  }
}
</style>
